/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalculationFunctionType } from '../../models/calculation-function-type';
import { DataStatsGroupedByAxis } from '../../models/data-stats-grouped-by-axis';
import { DataTimeStepType } from '../../models/data-time-step-type';
import { GraphDataValueType } from '../../models/graph-data-value-type';
import { HistoricalDataGraphBody } from '../../models/historical-data-graph-body';

export interface GetHistoricalDataStats$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The start date time of data to filter
 */
  startDateTime: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * Indicates the type of time interval to consider to aggregate the values:
 *   * SECOND : second
 *   * MINUTE : minute
 *   * HOUR : hour
 *   * DAY : day
 */
  dataTimeStepType?: DataTimeStepType & any;

/**
 * Indicates the time step range to consider, in conjunction with DataTimeStep (f.i. every 6 hours, every 10 minutes)
 */
  dataTimeStepRange?: number;

/**
 * Calculation function to be applied on a set of values:
 *   * RAW: Return the raw value
 *   * MIN: Return the minimum value in a given set of values
 *   * MAX: Return the maximum value in a given set of values
 *   * MEDIAN: Return the median value in a given set of values
 *   * AVERAGE: Return the average of a set of values
 */
  calculationFunction?: CalculationFunctionType & any;

/**
 * Indicates the data values to consider:
 *   * INITIAL_CORRECTED : work with the corrected values where possible, otherwise the initially acquired values if it has not been corrected
 *   * INITIAL_ONLY : work only with the initially acquired values
 *   * CORRECTED_ONLY : work only with the corrected values
 */
  graphDataValueType: GraphDataValueType & any;
  
    /**
     * Historical data graph options
     */
    body: HistoricalDataGraphBody
}

export function getHistoricalDataStats(http: HttpClient, rootUrl: string, params: GetHistoricalDataStats$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DataStatsGroupedByAxis>>> {
  const rb = new RequestBuilder(rootUrl, getHistoricalDataStats.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('dataTimeStepType', params.dataTimeStepType, {});
    rb.query('dataTimeStepRange', params.dataTimeStepRange, {});
    rb.query('calculationFunction', params.calculationFunction, {});
    rb.query('graphDataValueType', params.graphDataValueType, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DataStatsGroupedByAxis>>;
    })
  );
}

getHistoricalDataStats.PATH = '/stations/{uid}/graph/historical/stats';
